import { render } from "./LedgerReport.vue?vue&type=template&id=4d240ce0&scoped=true"
import script from "./LedgerReport.vue?vue&type=script&lang=js"
export * from "./LedgerReport.vue?vue&type=script&lang=js"

import "./LedgerReport.vue?vue&type=style&index=0&id=4d240ce0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d240ce0"]])

export default __exports__